import { z } from "zod";
import { ENTITY_TYPES } from "../../constants.js";
import { validateIncluded } from "../helpers/validateIncluded.js";

export const parsableCompanySchema = z.object({
    $type: z.literal(ENTITY_TYPES.DASH_COMPANY),
    entityUrn: z.string(),
    name: z.string(),
    url: z.string(),
    websiteUrl: z.string().nullish(),
    employeeCount: z.number().optional(),
    employeeCountRange: z
        .object({
            start: z.number().nullish(),
            end: z.number().nullish(),
        })
        .nullish(),
    foundedOn: z
        .object({
            year: z.number().nullish(),
        })
        .nullish(),
    "*industryV2Taxonomy": z.array(z.string()).nullish(),
    "*industry": z.array(z.string()).nullish(),
});
export const parsableIndustrySchema = z.object({
    $type: z.literal(ENTITY_TYPES.INDUSTRY),
    name: z.string(),
    entityUrn: z.string(),
});
export const parsableIndustryV2Schema = z.object({
    $type: z.literal(ENTITY_TYPES.INDUSTRY_V2),
    name: z.string(),
    entityUrn: z.string(),
});
export const parsableFollowingStateSchema = z.object({
    $type: z.literal(ENTITY_TYPES.DASH_FEED_FOLLOWING_STATE),
    entityUrn: z.string(),
    followerCount: z.number().optional(),
});
type ParsableFollowingState = z.infer<typeof parsableFollowingStateSchema>;
type ParsableCompany = z.infer<typeof parsableCompanySchema>;
type ParsableIndustry = z.infer<typeof parsableIndustrySchema>;
type ParsableIndustryV2 = z.infer<typeof parsableIndustryV2Schema>;
export const parsableGetCompanySchema = z.object({
    data: z.object({
        data: z.object({
            "*organizationDashCompaniesByIds": z.array(z.string()).min(1),
        }),
    }),
    included: z
        .array(
            z.union([
                parsableFollowingStateSchema,
                parsableCompanySchema,
                parsableIndustrySchema,
                parsableIndustryV2Schema,
                z.object({
                    $type: z.string(),
                }),
            ]),
        )
        .transform((datas, ctx) =>
            validateIncluded<ParsableCompany | ParsableFollowingState | ParsableIndustry | ParsableIndustryV2>({
                datas,
                ctx,
                typeSchemaRecord: {
                    [ENTITY_TYPES.DASH_FEED_FOLLOWING_STATE]: parsableFollowingStateSchema,
                    [ENTITY_TYPES.DASH_COMPANY]: parsableCompanySchema,
                    [ENTITY_TYPES.INDUSTRY]: parsableIndustrySchema,
                    [ENTITY_TYPES.INDUSTRY_V2]: parsableIndustryV2Schema,
                },
                preventError: true,
            }),
        ),
});
export const parsedGetCompanySchema = z.object({
    name: z.string(),
    linkedinUrl: z.string(),
    companyUrn: z.string().optional(),
    website: z.string().optional(),
    staffCount: z.number().optional(),
    size: z.string().optional(),
    industry: z.string().optional(),
    type: z.string().optional(),
    founded: z.number().optional(),
    followerCount: z.number().optional(),
});
